import {showToast} from "./toast";
import {trans} from "../i18n/i18n";
import {changeCurrency} from "../api/currency";
import {Toast} from "../consts/toast";

document.addEventListener('DOMContentLoaded', () => {
    initializeSettings();
});

let originalCurrency;

/**
 * Initializes the settings event listeners.
 */
function initializeSettings() {
    const currencySelector = document.getElementById('currency-selector');
    if (currencySelector) {
        originalCurrency = currencySelector.value;
        currencySelector.addEventListener('change', handleChangeCurrency);
    }
}

/**
 * Handles the change of currency selection.
 * @param {Event} event - The event triggered by changing the currency selector.
 */
function handleChangeCurrency(event) {
    const newCurrency = event.target.value;

    changeCurrency(newCurrency)
        .then(() => {
            showToast(trans("Currency successfully changed."), Toast.SUCCESS);
            originalCurrency = newCurrency;
        })
        .catch(() => {
            event.target.value = originalCurrency; // rollback to original currency
        });
}
